<script>
import RealtimeLeadsTable from "@/components/leads/RealtimeLeadsTable.vue";
import CommonCard from "../../../components/commonComponents/CommonCard.vue";

export default {
  name: "RealtimeLeadsDashboard",
  components: {CommonCard, RealtimeLeadsTable}
}
</script>

<template>
  <CommonCard>
    <div class="mt-2">
      <RealtimeLeadsTable/>
    </div>
  </CommonCard>
</template>

<style scoped>

</style>